/**
 * Allowed upload types for Income / Employment proof docs and Signature
 * government ID (Drivers License / Passport).
 *
 * Same `FILE_ACCEPT` as IncomeDocumentationSection (CS2NEW-1074) / Angular:
 * `.pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heic-sequence`
 * (UI copy: "PDF, JPG, JPEG, PNG, or HEIC").
 */

export const ACCEPTED_INCOME_AND_ID_DOCUMENT_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heic-sequence";

const ACCEPTED_EXTENSIONS = new Set([
  "pdf",
  "jpg",
  "jpeg",
  "png",
  "heic",
  "heif",
]);

const ACCEPTED_MIME_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/heic",
  "image/heic-sequence",
  "image/heif",
]);

export const ACCEPTED_INCOME_AND_ID_DOCUMENT_ERROR =
  "Only PDF, JPG, JPEG, PNG, or HEIC files are allowed.";

export function getFileExtensionFromName(fileName: string): string {
  if (!fileName) return "";
  const clean = fileName.split("?")[0];
  return clean.includes(".") ? clean.split(".").pop()!.toLowerCase() : "";
}

/** True when the file is an allowed income/ID document (by extension or MIME). */
export function isAcceptedIncomeOrIdDocumentFile(file: File): boolean {
  const ext = getFileExtensionFromName(file.name);
  if (ext && ACCEPTED_EXTENSIONS.has(ext)) return true;

  const mime = (file.type || "").toLowerCase();
  return Boolean(mime && ACCEPTED_MIME_TYPES.has(mime));
}
